import styled from "styled-components";
import CompleteImg from "assets/images/img_.png";

const InquiryCompleteWrapper = styled.div`
  padding-top: 8rem;
  text-align: center;

  .txt_title {
    font-size: 2.2rem;
    font-weight: 600;
    line-height: 2.6rem;
  }

  .txt_title::before {
    display: block;
    width: 8rem;
    height: 8rem;
    margin: 0 auto 4rem;
    background: url(${CompleteImg}) no-repeat center;
    background-size: 8rem;
    content: "";
  }

  .txt_desc {
    margin-top: 4rem;
    line-height: 2.2rem;
  }
`;

const InquiryComplete = () => {
  return (
    <>
      <InquiryCompleteWrapper>
        <h2 className="txt_title">문의가 접수되었습니다.</h2>
        <p className="txt_desc">
          문의가 성공적으로 접수되었습니다.
          <br />
          입력하신 이메일 주소로 답변 드리겠습니다.
          <br />
          <br />
          감사합니다
        </p>
      </InquiryCompleteWrapper>
    </>
  );
};

export default InquiryComplete;
